export const photos = {
  august: [
    { src: "/magazine-z/en/skygunner-comic 0.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 1.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 2.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 3.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 4.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 5.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 6.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 7.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 8.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 9.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 10.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 11.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 12.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 13.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 14.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 15.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 16.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 17.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 18.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 19.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 20.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 21.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 22.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 23.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 24.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 25.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 26.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 27.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 28.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 29.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 30.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 31.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 32.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 33.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 34.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 35.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 36.jpg", width: 1, height: 1 },
  ],
  september: [
    { src: "/magazine-z/en/skygunner-comic 37.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 38.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 39.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 40.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 41.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 42.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 43.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 44.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 45.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 46.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 47.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 48.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 49.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 50.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 51.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 52.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 53.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 54.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 55.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 56.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 57.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 58.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 59.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 60.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 61.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 62.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 63.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 64.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 65.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 66.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 67.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 68.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 69.jpg", width: 1, height: 1 },
    { src: "/magazine-z/en/skygunner-comic 70.jpg", width: 1, height: 1 },
  ],
  hentai: [
    { src: "/くりとるぽこんつにゃ～/en/01.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/02.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/03.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/04.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/05.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/06.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/07.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/08.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/09.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/10.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/11.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/12.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/13.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/14.webp", width: 1, height: 1 },
    { src: "/くりとるぽこんつにゃ～/en/15.webp", width: 1, height: 1 },
  ],
  guidebook: [
    { src: "/guidebook/skygunner-guide 0.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 1.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 2.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 3.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 4.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 5.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 6.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 7.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 8.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 9.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 10.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 11.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 12.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 13.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 14.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 15.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 16.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 17.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 18.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 19.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 20.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 21.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 22.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 23.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 24.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 25.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 26.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 27.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 28.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 29.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 30.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 31.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 32.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 33.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 34.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 35.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 36.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 37.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 38.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 39.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 40.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 41.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 42.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 43.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 44.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 45.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 46.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 47.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 48.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 49.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 50.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 51.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 52.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 53.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 54.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 55.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 56.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 57.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 58.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 59.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 60.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 61.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 62.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 63.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 64.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 65.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 66.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 67.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 68.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 69.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 70.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 71.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 72.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 73.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 74.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 75.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 76.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 77.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 78.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 79.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 80.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 81.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 82.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 83.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 84.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 85.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 86.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 87.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 88.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 89.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 90.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 91.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 92.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 93.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 94.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 95.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 96.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 97.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 98.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 99.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 100.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 101.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 102.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 103.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 104.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 105.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 106.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 107.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 108.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 109.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 110.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 111.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 112.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 113.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 114.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 115.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 116.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 117.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 118.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 119.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 120.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 121.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 122.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 123.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 124.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 125.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 126.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 127.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 128.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 129.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 130.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 131.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 132.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 133.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 134.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 135.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 136.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 137.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 138.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 139.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 140.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 141.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 142.png", width: 1, height: 1 },
    { src: "/guidebook/skygunner-guide 143.png", width: 1, height: 1 },
  ],
};
